import { Link } from "react-router-dom";
import { BrandedHeading, RawsterBrand } from "./RawsterBrand";

const features = [
  {
    icon: "◎",
    title: "Connection Tracking",
    description:
      "Keep a clear, private record of the people in your life, dates, dynamics, and how each connection evolves over time.",
  },
  {
    icon: "◆",
    title: "Pulses",
    description:
      "Quick check ins that capture how you feel in the moment, so patterns in mood and energy become easier to understand.",
  },
  {
    icon: "◇",
    title: "Relationship Insights",
    description:
      "Thoughtful summaries that help you see trends in your relationships without judgment or pressure.",
  },
  {
    icon: "◈",
    title: "Personality & Attachment Style",
    description:
      "Gentle frameworks to explore how you connect, your tendencies, needs, and growth areas in dating and beyond.",
  },
  {
    icon: "◉",
    title: "Private Self Awareness Tools",
    description:
      "Journaling, reflection prompts, and personal notes that stay on your device, built for honesty, not performance.",
  },
];

export function RawsterLandingPage() {
  return (
    <main className="rawster-main">
      <section className="rawster-hero" aria-labelledby="rawster-hero-title">
        <span className="rawster-hero-badge">Modern dating · Self awareness</span>
        <RawsterBrand as="h1" id="rawster-hero-title" className="rawster-brand-hero" />
        <p className="rawster-hero-tagline">
          Understand your connections. Know yourself better.
        </p>
        <p className="rawster-hero-desc">
          Rawster is a private companion for modern dating and relationships. Track
          connections, notice patterns with Pulses, and build self awareness, without
          the noise of social feeds or public profiles.
        </p>
        <div className="rawster-cta-row">
          <a
            href="#features"
            className="rawster-btn rawster-btn-primary"
          >
            Explore features
          </a>
          <Link to="/rawster/support" className="rawster-btn rawster-btn-secondary">
            Get support
          </Link>
        </div>
      </section>

      <section className="rawster-about" aria-labelledby="rawster-about-title">
        <BrandedHeading as="h2" id="rawster-about-title">
          Dating with clarity, not chaos
        </BrandedHeading>
        <p>
          Whether you are meeting someone new or reflecting on an existing bond,
          Rawster gives you a calm space to log what matters, check in with yourself,
          and grow emotional intelligence, on your terms, in your pocket.
        </p>
      </section>

      <section
        id="features"
        className="rawster-features"
        aria-labelledby="rawster-features-title"
      >
        <BrandedHeading as="h2" id="rawster-features-title">
          Everything you need to stay grounded
        </BrandedHeading>
        <p className="rawster-features-intro">
          Simple tools designed for real life, private by default, focused on insight
          over endless scrolling.
        </p>
        <div className="rawster-feature-grid">
          {features.map((feature) => (
            <article key={feature.title} className="rawster-feature-card">
              <div className="rawster-feature-icon" aria-hidden="true">
                {feature.icon}
              </div>
              <BrandedHeading as="h3">{feature.title}</BrandedHeading>
              <p>{feature.description}</p>
            </article>
          ))}
        </div>
      </section>
    </main>
  );
}
